module.exports = __webpack_public_path__ + "static/b4-688922cd536f283ab0c7bd1ec6ab2e5f.jpg";